<template>
  <nav class="o-menu">
    <ul class="o-menu__wrap o-menu__wrap--parent">
      <li class="o-menu__item" v-for="(item, index) in pages" :key="index">
        <router-link class="o-menu__link" :to="`/${item.parent.slug}`" @click.native="$store.commit('setMenu', false)"><svg class="c-icon c-icon--house o-menu__home" v-if="index === 0"><use xlink:href="#icon-house"></use></svg>{{ item.parent.title }}</router-link>
        <ul class="o-menu__wrap o-menu__wrap--nested" v-if="item.children && !primaryOnly">
          <li class="o-menu__item" v-for="(subItem, subIndex) in item.children" :key="subIndex"><router-link class="o-menu__link" :to="`/${item.parent.slug}/${subItem.slug}`" @click.native="$store.commit('setMenu', false)">{{ subItem.title }}</router-link></li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MyMenu',
  props: {
    primaryOnly: Boolean
  },
  computed: {
    ...mapState(['pages'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/objects/MyMenu.vue